import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button, Card, Field, Input } from '@rahul365/ui';
import { Download, LockKeyhole } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { ApiError, api } from '../lib/api.js';
import type { SessionResponse } from '../types.js';

export function LoginPage() {
  const queryClient = useQueryClient();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const login = useMutation({
    mutationFn: () => api<SessionResponse>('/api/v1/auth/login', { method: 'POST', body: JSON.stringify({ email, password }) }),
    onSuccess: (data) => queryClient.setQueryData(['session'], data),
  });
  const submit = (event: FormEvent) => {
    event.preventDefault();
    login.mutate();
  };

  return (
    <main className="auth-page">
      <div className="auth-page__intro">
        <span className="brand-mark brand-mark--large">R365</span>
        <span className="eyebrow">PRIVATE HEALTH &amp; FITNESS OS</span>
        <h1>Build the year.<br />One useful action at a time.</h1>
        <p>Training, nutrition, activity, recovery and progress—kept together and kept private.</p>
      </div>
      <Card className="auth-card">
        <LockKeyhole className="auth-card__icon" aria-hidden="true" />
        <h2>Welcome back, Rahul</h2>
        <p>Your health data is protected by your private account.</p>
        <form onSubmit={submit}>
          <Field label="Email"><Input autoComplete="username" inputMode="email" type="email" required value={email} onChange={(event) => setEmail(event.target.value)} /></Field>
          <Field label="Password"><Input autoComplete="current-password" type="password" minLength={12} required value={password} onChange={(event) => setPassword(event.target.value)} /></Field>
          {login.error ? <p className="form-error">{login.error instanceof ApiError ? login.error.message : 'Sign-in is temporarily unavailable.'}</p> : null}
          <Button disabled={login.isPending} type="submit">{login.isPending ? 'Opening Rahul 365…' : 'Sign in'}</Button>
        </form>
        <a className="button button--secondary auth-download" href="/download/rahul365.apk" download="RAHUL-365.apk"><Download /> Download Android app</a>
        <small>No Expo Go needed. Download and install the signed APK directly.</small>
        <small>Only connect from a device you trust.</small>
      </Card>
    </main>
  );
}
